export default __webpack_public_path__ + "static/media/Spiroflow.9785bffb.png";